import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import searchIcon from '../../assets/search.svg'
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect } from "react";
import { json, Link } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRightAltRounded, LinkRounded, Public, Search } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import Statbox from "../Dashborad/Statbox";
import CustomTabBar from "../Utils/CustomTabBar";
import { CircleLoader } from "react-spinners";

const ClubsListScreen = () => {


    return <CommunityListView />;
};
const Convert_Time_Zone = (isostring) => {
    const date = new Date(isostring); // works for ISO string & ObjectId date

    return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
    });
};
function CommunityListView({ data }) {
    const [locations, setlocations] = useState(null);
    const [UserLastLocation, setUserLastLocation] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTab, setSelectedTab] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)
    const [hasEnded, setHasEnded] = useState(false)
    const [searchedEvents, setSearchedEvents] = useState([])
    const [searchQuery, setSearchQuery] = useState("")
    const [metricData, setMetricData] = useState({})
    const [loading, setLoading] = useState(false)

    const FetchEvents = async (page, type) => {

        if (page == 1) {
            setHasEnded(false)
            setEvents([])
        }
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/clubs/get-clubs?page=${page}&limit=${30}&type=${type}${page == 1 ? `&d_data=true` : ""}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setEvents(prev => page == 1 ? data.response : [...prev, ...data.response]);
            setCurrentPage(page)
            if (data.response.length < 30) {
                setHasEnded(true)
            }
            setLoading(false);
        } else {
            setLoading(false)
        }

    };


    const FetchClubsMetrics = async () => {

        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/clubs/get-clubs-metrics`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setMetricData(data?.response ?? {})
        }

    };

    const SearchEvents = async (q) => {
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/events/search?q=${q}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setSearchedEvents(data.data);
        }
        setLoading(false)
    };

    useEffect(() => {
        FetchClubsMetrics()
        FetchEvents(1, "0");
    }, []);

    useEffect(() => {
        if (searchQuery.length > 0) {
            const delayDebounceFn = setTimeout(() => {
                SearchEvents(searchQuery);
            }, 500); // 500ms delay

            return () => clearTimeout(delayDebounceFn);
        } else {
            setSearchedEvents([]); // Clear results when input is empty
        }
    }, [searchQuery]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [events, setEvents] = useState([])

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')


    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>

                <Box
                    display={"flex"}
                    justifyContent="space-between"
                    alignItems={"center"}
                >
                    <Header
                        title={`Clubs & Directories`}
                        subtitle={"Manage and moniter all the clubs and directories"}
                    />
                </Box>

                <Box
                    display={"grid"}
                    gridTemplateColumns="repeat(12,1fr)"
                    gridAutoRows={"100px"}
                    pb={"20px"}
                    gap={(isMobileScreen || isTabScreen) ? "20px" : "20px"}
                >
                    {/* ROW 1 */}
                    <Box
                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 4"}
                        sx={{
                            borderRadius: "20px",
                            border: "1.7px solid transparent",
                            background:
                                "linear-gradient(#ffffff00 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#943bff, rgba(214, 152, 36, 1)) border-box",

                        }}
                        display="flex"
                        alignItems={"center"}
                        justifyContent="center"
                    >
                        <Statbox
                            title={metricData.totalClubs ?? 0}
                            subtitle="Total Campus Clubs"
                            users={true}
                            report={0}
                        />
                    </Box>

                    <Box
                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 4"}
                        sx={{
                            background: "#ffffff08",
                            borderRadius: "20px",
                            border: "1.5px solid #aaaaaa05",
                        }}
                        display="flex"
                        alignItems={"center"}
                        justifyContent="center"
                    >
                        <Statbox
                            title={metricData.totalDirectories ?? 0}
                            subtitle="Total Business Directories"
                            loading={false}



                            users={true}
                            report={0}
                        />
                    </Box>
                    <Box
                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 4"}
                        sx={{
                            background: "#ffffff08",
                            borderRadius: "20px",
                            border: "1.5px solid #aaaaaa05",
                        }}
                        display="flex"
                        alignItems={"center"}
                        justifyContent="center"
                    >
                        <Statbox
                            title={metricData.totalContent ?? 0}
                            subtitle="Total Content Shared"
                            loading={false}
                            users={true}
                            report={0}
                        />
                    </Box>





                </Box>


                <Box sx={{
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: "center",
                    marginBottom: "20px",
                }}>
                    <Box sx={{
                        flexDirection: 'row',
                        display: 'flex',
                        borderRadius: "15px",
                        border: "1px solid #aaaaaa10",
                        background: "#ffffff08",
                        maxWidth: isMobileScreen ? "100%" : isTabScreen ? "80%" : "32.5%",
                        minWidth: isMobileScreen ? "100%" : "500px"
                    }}>

                        <img
                            alt="search_icon"
                            width="20px"
                            height="20px"
                            style={{
                                objectFit: 'contain',
                                filter: 'invert(1) hue-rotate(180deg) brightness(1)',
                                alignSelf: 'center',
                                marginLeft: "15px"
                            }}
                            src={searchIcon}
                        />
                        <input
                            placeholder="Search club by name..."
                            enterKeyHint={'search'}
                            value={searchQuery}
                            // onKeyDown={(e) => {
                            //     if (e.key === "search" || e.key === "enter") {
                            //         searchEvent(e.target.value)
                            //         e.target.value = "";
                            //     }
                            // }}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                                outline: 'none',
                                backgroundColor: "transparent",
                                borderWidth: 0,
                                padding: "15px 15px",
                                flex: 1,
                                fontSize: "14px",
                                fontFamily: 'poppins-reg',
                                color: "white"
                            }}
                        />


                    </Box>


                </Box>



                <CustomTabBar
                    selectedTab={selectedTab}
                    tabs={["Campus Clubs", "Business Directories"]}
                    marginBottom="10px"
                    gap={isMobileScreen ? "12px" : "15px"}
                    fontSize={isMobileScreen ? "15px" : "18px"}
                    nonSelectedFontSize={isMobileScreen ? "12px" : "13px"}
                    marginLeft="5px"
                    onChange={(index) => {
                        setSelectedTab(index)
                        FetchEvents(1, `${index}`)
                    }}

                />



                <Box display={"flex"} flexDirection={'column'} alignSelf={'stretch'} alignItems={'stretch'}>

                    <Box
                        display={"flex"}
                        gap="20px"
                        sx={{
                            flexWrap: 'wrap',
                            flexDirection: 'row'
                        }}
                        pb={"20px"}
                    >
                        {
                            (searchQuery.length > 0 ? searchedEvents : events).map((community) => {
                                return (
                                    <Box
                                        // key={`${transaction.txId}-${i}`}

                                        display="flex"
                                        component={Link}
                                        borderRadius={"10px"}
                                        to={{
                                            pathname: "/admin/club-dt",
                                            search: `?ref=${community._id}`,
                                            state: { fromDashboard: true },
                                            // console.log(first)
                                        }}

                                        sx={{
                                            textDecoration: 'none', flexDirection: 'row',
                                            display: 'flex', width: isMobileScreen ? "100%" : "300px",
                                            background: "#ffffff08", borderRadius: "15px",
                                            paddingInline: "10px", paddingBlock: "10px"

                                        }}
                                    >
                                        <Box sx={{
                                            display: 'flex', alignItems: 'center', alignSelf: 'flex-start',
                                            position: "relative", flexDirection: "column"
                                        }}>
                                            <img
                                                alt="club-logo"
                                                width={"80px"}
                                                src={`${community.clubLogo}`}
                                                style={{
                                                    aspectRatio: 1 / 1,
                                                    cursor: "pointer", objectFit: 'cover',
                                                    borderRadius: "15px",
                                                    border: "2px solid #ffffff05"
                                                }}
                                            />

                                            <Box sx={{ width: "100%", height: "100%", position: "absolute", background: "#00000010" }} />


                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', marginInline: "10px" }}>
                                            <Typography color={"#ffffff"}
                                                fontFamily={"poppins-reg"}
                                                fontSize={"15px"}
                                                style={{
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 1,      // change to 3,4 if needed
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden"
                                                }}
                                            >{community.title}</Typography>

                                            <Typography color={"#aaaaaa"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    marginTop: "2px",
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 1,      // change to 3,4 if needed
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden"
                                                }}
                                                fontSize={"11px"}>{community.locationName}</Typography>

                                            <Box sx={{
                                                flex: 1,
                                                display: "flex"
                                            }} />

                                            <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex", gap: "5px", marginBottom: "4px" }} >

                                                {
                                                    community.space && (
                                                        <LinkRounded
                                                            style={{
                                                                color: "#943bff",
                                                                fontSize: "21px",
                                                                borderRadius: "3px",
                                                                background: "#943bff30",
                                                                paddingInline: "3px",
                                                                paddingBlock: "0px"
                                                            }}
                                                        />
                                                    )
                                                }


                                                {
                                                    (community?.community?.length ?? 0) > 0 && (
                                                        <Typography color={community?.community?.length > 1 ? "#ff8800" : "#ffffff90"}
                                                            fontFamily={"poppins-reg"}
                                                            style={{
                                                                display: "-webkit-box",
                                                                background: community?.community?.length > 1 ? "#ff880010" : "#ffffff10",
                                                                paddingInline: "8px",
                                                                borderRadius: "4px",
                                                                paddingBlock: "2px",
                                                                alignSelf: "flex-start",
                                                                WebkitLineClamp: 1,      // change to 3,4 if needed
                                                                WebkitBoxOrient: "vertical",
                                                                overflow: "hidden"
                                                            }}
                                                            fontSize={"11px"}>{community?.community?.length ?? 0} Communities</Typography>
                                                    )
                                                }

                                            </Box>

                                        </Box>

                                    </Box>
                                );
                            })}
                    </Box>


                    {
                        hasEnded && !loading && (
                            <Box sx={{
                                alignSelf: "center", paddingBlock: "8px", paddingInline: "30px", marginBottom: "20px", marginTop: "10px",
                                fontFamily: "poppins-reg", fontSize: "12px", color: "#ffffff90"
                            }} >- Looks like you have reached to the end -</Box>
                        )
                    }

                    {
                        !hasEnded && !loading && (
                            <Box onClick={() => {
                                if (!hasEnded) {
                                    FetchEvents(currentPage + 1, `${selectedTab}`)
                                }
                            }} sx={{
                                alignSelf: "center", paddingBlock: "8px", paddingInline: "30px", marginBottom: "20px", marginTop: "10px",
                                fontFamily: "poppins-reg", fontSize: "13px", borderRadius: "10px", border: "1px solid #943bff",
                                background: "#943bff20", cursor: "pointer",
                            }} >Load More</Box>
                        )
                    }

                </Box>

            </Box>
        </>
    );
}

export default ClubsListScreen;
